<template>
  <div>
    <div :id="id" class="experience-canvas"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'

export default {
  props: {
    id: {
      type: String,
      default: 'main'
    }
  },
  data() {
    return {
      chart: undefined,
      stackInfo: {},
      series: [
        {
          data: [4.9, 4.7, 4.93, 4.78, 4.85, 4.68],
          type: 'line',
          // smooth: true,
          name: '客户评分',
          color: '#3C6EF0',
          label: {
            show: true,
            position: 'top'
          },
        }
      ],
      option: {
        xAxis: {
          type: 'category',
          data: ['2023-07', '2023-08', '2023-09', '2023-10', '2023-11', '2023-12'],
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },

        legend: {
          bottom: 0,
          itemWidth: 10, // 设置图例项的宽度
          itemHeight: 10, // 设置图例项的高度
          itemStyle: {
            borderRadius: 10,
          },
          itemGap: 16, // 横向布局时为水平间隔，纵向布局时为纵向间隔
          data: ['客户评分'],
          icon: 'circle'
        },
        grid: {
          top: '5%',
          // bottom: '10%',
          left: '8%',
          right: '0%',
        },
      }
    }
  },
  mounted() {
    this.getData()
    this.option.series = this.series
    const chartDom = document.getElementById(`${this.id}`)
    // 调整canvas清晰度
    this.chart = echarts.init(chartDom, null, { devicePixelRatio: 2.5 })
    // this.chart = echarts.init(chartDom, null, { renderer: 'svg' })
    this.chart.setOption(this.option)
  },
  methods: {
    getData() {
      const { series, stackInfo } = this
      for (let i = 0; i < series[0].data.length; ++i) {
        for (let j = 0; j < series.length; ++j) {
          const stackName = series[j].stack
          if (!stackName) {
            // continue
          }
          if (!stackInfo[stackName]) {
            stackInfo[stackName] = {
              stackStart: [],
              stackEnd: []
            }
          }
          const info = stackInfo[stackName]
          const data = series[j].data[i]
          if (data && data !== '-') {
            if (info.stackStart[i] == null) {
              info.stackStart[i] = j
            }
            info.stackEnd[i] = j
          }
          stackInfo[stackName] = info
        }
      }
      for (let i = 0; i < series.length; ++i) {
        const info = stackInfo[series[i].stack]
        for (let j = 0; j < series[i].data.length; ++j) {
          const isEnd = info.stackEnd[j] === i
          const topBorder = isEnd ? 20 : 0
          const bottomBorder = 0
          series[i].data[j] = {
            value: series[i].data[j],
            itemStyle: {
              borderRadius: [topBorder, topBorder, bottomBorder, bottomBorder]
            }
          }
        }
      }
      this.series = series
      this.stackInfo = stackInfo
    },
  }
}
</script>

<style lang="scss" scoped>
.experience-canvas {
  width: 566px;
  height: 362px;
  // border: 1px solid #eee;
  background-color: #fff;
}
</style>
